export default __webpack_public_path__ + "c75547b.png";